import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavigationService } from '@h5s/design-system';
import { FeatureUserStore } from '@h5s/feature-user';

/**
 * Guard per verificare se l'utente ha selezionato una proprietà
 *
 * @returns true se la proprietà è selezionata, false altrimenti
 */
export const propertySelectedGuard: CanActivateFn = () => {
  const featureUserStore = inject(FeatureUserStore);
  const navigationService = inject(NavigationService);

  if (!featureUserStore.isUserLoggedInProperty()) {
    navigationService.navigate('./pick-your-place');
    return false;
  }

  return true;
};
